import httpService from "../../../../services/httpService";

const getOffsetTime = () => {
  const offset = new Date().getTimezoneOffset();
  const sign = offset > 0 ? "-" : "+";
  const abs = Math.abs(offset);
  return `${sign}${String(Math.floor(abs / 60)).padStart(2, "0")}:${String(abs % 60).padStart(2, "0")}`;
};

const ScheduleClient = {
  list: async (params?: {
    page_number?: number;
    limit?: number;
    session_name?: string;
    status?: string;
    offset_time?: string;
    round_id?: string;
    job_opportunity_id?: string;
  }) => {
    const response = await httpService.get("/interview_admin/schedules", {
      params,
    });
    return response.data;
  },

  get: async (id: string) => {
    const response = await httpService.get(
      `/interview_admin/schedules/${id}`,
    );
    return response.data;
  },

  create: async (data: any) => {
    const response = await httpService.post("/interview_admin/schedules", data);
    return response.data;
  },

  update: async (id: string, data: any) => {
    const response = await httpService.post(
      `/interview_admin/schedules/${id}`,
      data,
    );
    return response.data;
  },

  delete: async (id: string) => {
    const response = await httpService.delete(
      `/interview_admin/schedules/${id}`,
    );
    return response.data;
  },

  uploadDescriptionFile: async (
    file: File,
    scheduleId?: string,
    oldS3Key?: string,
  ) => {
    const formData = new FormData();
    formData.append("file", file);
    let url = "/interview_admin/schedule/upload_description_file";
    const params: string[] = [];
    if (scheduleId)
      params.push(`schedule_id=${encodeURIComponent(scheduleId)}`);
    if (oldS3Key) params.push(`old_s3_key=${encodeURIComponent(oldS3Key)}`);
    if (params.length > 0) url += `?${params.join("&")}`;

    const response = await httpService.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  companyUsers: async (params?: {
    page_number?: number;
    limit?: number;
    emails?: string;
    status?: string;
  }) => {
    const response = await httpService.get("/interview_admin/users", {
      params,
    });
    return response.data;
  },

  listRounds: async () => {
    const response = await httpService.get("/interview/rounds");
    return response.data;
  },
};

export default ScheduleClient;
